import { ConfigurationPropertyValues } from "src/api/generated/erp/configurator/model/configurationPropertyValues.ts";

export interface ConfigurationCheckpointState {
	previousPropertyValues: ConfigurationPropertyValues | null;
	entries: ConfigurationCheckpointEntry[];
	lastCheckpointInputVersion: number;
}

export interface ConfigurationCheckpointEntry {
	description: string;
	price: ConfigurationCheckpointEntryPrice | null;
}

export interface ConfigurationCheckpointEntryPrice {
	salesPriceWithVat: number;
	salesPriceDiff: number | null;
	sellingCurrencyCode: string;
}

export const defaultCheckpointState: ConfigurationCheckpointState = {
	previousPropertyValues: null,
	entries: [],
	lastCheckpointInputVersion: -1,
};
